import React, { useEffect, useState } from "react";
import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";
import { useNavigate } from "react-router-dom";
import ourServices from "./ourServicesContent";

import "../../styles/ourServices/style.scss";

const OurServicesComponent = ({ ref }) => {
  const [serviceData, setServiceData] = useState(ourServices.ourServices);
  const navigate = useNavigate();
  let speed = 30000;

  const serviceCardOnClickFunc = (name) => {
    navigate(`/services/${name}`);
  };

  return (
    <div className="our-services-wrapper" ref={ref}>
      <div className="our-services-heading">Our Services</div>
      <div className="our-services-sub-heading">
        Comprehensive digital solutions tailored to your business needs.
      </div>
      {/* desktopView */}
      <div className="our-services-card-wrapper">
        <div className="our-service-sub-card-wrapper">
          <div className="wrapper">
            <section
              className="right-to-left-move"
              style={{ "--speed": `${speed}ms` }}
            >
              {serviceData?.map((service) => (
                <Card
                  key={service?.id}
                  className="our-service-card width-20 cursor-pointer"
                  onClick={() => {
                    serviceCardOnClickFunc(service.name);
                  }}
                >
                  <CardContent>
                    <img src={service?.image} alt={service?.name} />
                    <div className="our-service-card-content">
                      {service?.name}
                    </div>
                  </CardContent>
                </Card>
              ))}
            </section>
            <section
              className="right-to-left-move"
              style={{ "--speed": `${speed}ms` }}
            >
              {serviceData?.map((service) => (
                <Card
                  key={service?.id}
                  className="our-service-card width-20 cursor-pointer"
                  onClick={() => {
                    serviceCardOnClickFunc(service.name);
                  }}
                >
                  <CardContent>
                    <img src={service?.image} alt={service?.name} />
                    <div className="our-service-card-content">
                      {service?.name}
                    </div>
                  </CardContent>
                </Card>
              ))}
            </section>
          </div>
        </div>
        <div className="our-service-sub-card-wrapper">
          <div className="wrapper">
            <section
              className="left-to-right-move"
              style={{ "--speed": `${speed}ms` }}
            >
              {serviceData?.reverse().map((service) => (
                <Card
                  key={service?.id}
                  className="our-service-card width-20 cursor-pointer"
                  onClick={() => {
                    serviceCardOnClickFunc(service.name);
                  }}
                >
                  <CardContent>
                    <img src={service?.image} alt={service?.name} />
                    <div className="our-service-card-content">
                      {service?.name}
                    </div>
                  </CardContent>
                </Card>
              ))}
            </section>
            <section
              className="left-to-right-move"
              style={{ "--speed": `${speed}ms` }}
            >
              {serviceData?.map((service) => (
                <Card
                  key={service?.id}
                  className="our-service-card width-20 cursor-pointer"
                  onClick={() => {
                    serviceCardOnClickFunc(service.name);
                  }}
                >
                  <CardContent>
                    <img src={service?.image} alt={service?.name} />
                    <div className="our-service-card-content">
                      {service?.name}
                    </div>
                  </CardContent>
                </Card>
              ))}
            </section>
          </div>
        </div>
      </div>
      {/* mobileResponsive */}
      <div className="our-services-card-wrapper-mobile-view">
        <div className="our-service-sub-card-wrapper-mobile">
          <div className="our-service-sub-card-wrapper">
            <div className="wrapper">
              <section
                className="right-to-left-move"
                style={{ "--speed": `${speed}ms` }}
              >
                {serviceData?.slice(0, 5)?.map((service) => (
                  <Card
                    key={service?.id}
                    className="our-service-card width-20 cursor-pointer"
                    onClick={() => {
                      serviceCardOnClickFunc(service.name);
                    }}
                  >
                    <CardContent>
                      <img src={service?.image} alt={service?.name} />
                      <div className="our-service-card-content">
                        {service?.name}
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </section>
              <section
                className="right-to-left-move"
                style={{ "--speed": `${speed}ms` }}
              >
                {serviceData?.slice(5, 10)?.map((service) => (
                  <Card
                    key={service?.id}
                    className="our-service-card width-20 cursor-pointer"
                    onClick={() => {
                      serviceCardOnClickFunc(service.name);
                    }}
                  >
                    <CardContent>
                      <img src={service?.image} alt={service?.name} />
                      <div className="our-service-card-content">
                        {service?.name}
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </section>
              <section
                className="right-to-left-move"
                style={{ "--speed": `${speed}ms` }}
              >
                {serviceData?.slice(5, 10)?.map((service) => (
                  <Card
                    key={service?.id}
                    className="our-service-card width-20 cursor-pointer"
                    onClick={() => {
                      serviceCardOnClickFunc(service.name);
                    }}
                  >
                    <CardContent>
                      <img src={service?.image} alt={service?.name} />
                      <div className="our-service-card-content">
                        {service?.name}
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </section>
            </div>
          </div>
          <div className="our-service-sub-card-wrapper">
            <div className="wrapper">
              <section
                className="left-to-right-move"
                style={{ "--speed": `${speed}ms` }}
              >
                {serviceData
                  ?.reverse()
                  .slice(0, 5)

                  .map((service) => (
                    <Card
                      key={service?.id}
                      className="our-service-card width-20 cursor-pointer"
                      onClick={() => {
                        serviceCardOnClickFunc(service.name);
                      }}
                    >
                      <CardContent>
                        <img src={service?.image} alt={service?.name} />
                        <div className="our-service-card-content">
                          {service?.name}
                        </div>
                      </CardContent>
                    </Card>
                  ))}
              </section>
              <section
                className="left-to-right-move"
                style={{ "--speed": `${speed}ms` }}
              >
                {serviceData
                  ?.slice(5, 10)

                  .map((service) => (
                    <Card
                      key={service?.id}
                      className="our-service-card width-20 cursor-pointer"
                      onClick={() => {
                        serviceCardOnClickFunc(service.name);
                      }}
                    >
                      <CardContent>
                        <img src={service?.image} alt={service?.name} />
                        <div className="our-service-card-content">
                          {service?.name}
                        </div>
                      </CardContent>
                    </Card>
                  ))}
              </section>
              <section
                className="left-to-right-move"
                style={{ "--speed": `${speed}ms` }}
              >
                {serviceData
                  ?.slice(5, 10)

                  .map((service) => (
                    <Card
                      key={service?.id}
                      className="our-service-card width-20 cursor-pointer"
                      onClick={() => {
                        serviceCardOnClickFunc(service.name);
                      }}
                    >
                      <CardContent>
                        <img src={service?.image} alt={service?.name} />
                        <div className="our-service-card-content">
                          {service?.name}
                        </div>
                      </CardContent>
                    </Card>
                  ))}
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurServicesComponent;
